





 
import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams, useNavigate ,useSearchParams} from "react-router-dom";
import { getEmployeesApi, getProfileApi, getUserByIdApi, updateUserApi } from "../../app/api";
import UserAttendance from "../profile/UserAttendanceProfile";
import UserDocuments from "../profile/UserDocuments";
import UserLeavesProfile from "../profile/UserLeavesProfile";
import TaskDetails from "../../pages/dashboard/components/TaskDetails";
import UserJourney from "../../components/Tasks/UserJourney";
import { formatDisplayDate, getDateInputValue } from "../../utils/dateFormat";
import toast from "react-hot-toast";
import { Camera, Pencil, Save, X } from "lucide-react";
import { convertImageToWebP } from "../../utils/convertImageToWebP";
 
import { useLocation } from "react-router-dom";
const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

const getUserIdentityValues = (item = {}) =>
  [item.id, item.user_id, item.employee_id, item.emp_id]
    .filter((value) => value !== undefined && value !== null)
    .map(String);

const getLookupIds = (routeId, item = {}) =>
  [
    item.id,
    item.user_id,
    item.userId,
    item.employee_user_id,
    routeId,
    item.employee_id,
    item.employeeId,
    item.emp_id,
  ]
    .filter((value) => value !== undefined && value !== null && value !== "")
    .map(String)
    .filter((value, index, all) => all.indexOf(value) === index);

const hasValue = (value) =>
  value !== undefined && value !== null && value !== "";

const getNameKey = (item = {}) =>
  [
    item.name,
    [item.first_name, item.last_name].filter(Boolean).join(" "),
    item.employee_name,
  ]
    .find(Boolean)
    ?.trim()
    .toLowerCase() || "";

const mergeUserRecords = (...records) =>
  records.reduce((merged, record) => {
    if (!record) return merged;

    Object.entries(record).forEach(([key, value]) => {
      if (hasValue(value) || !hasValue(merged[key])) {
        merged[key] = value;
      }
    });

    return merged;
  }, {});

const normalizeUserShape = (item = {}, id) => {
  const [firstName = "", ...lastNameParts] = String(item.name || "").trim().split(/\s+/);

  return {
    ...item,
    id: item.id || item.user_id || item.employee_id || id,
    user_id: item.user_id || item.id || item.employee_id || id,
    first_name: item.first_name || firstName,
    last_name: item.last_name || lastNameParts.join(" "),
  };
};

const collectUsersFromResponse = (response) => {
  const queue = [response];
  const users = [];
  const seen = new Set();

  while (queue.length) {
    const candidate = queue.shift();
    if (!candidate || typeof candidate !== "object" || seen.has(candidate)) continue;

    seen.add(candidate);

    if (getUserIdentityValues(candidate).length || candidate.name || candidate.first_name) {
      users.push(candidate);
    }

    if (Array.isArray(candidate)) {
      queue.push(...candidate);
    } else {
      queue.push(...Object.values(candidate));
    }
  }

  return users;
};

const findUserInResponse = (response, ids, referenceUser = null) => {
  const lookupIds = Array.isArray(ids) ? ids.map(String) : [String(ids)];
  const routeId = lookupIds[0];
  const normalizedReference = referenceUser ? normalizeUserShape(referenceUser, routeId) : null;
  const referenceName = getNameKey(normalizedReference);

  const match = collectUsersFromResponse(response).find((candidate) => {
    const identities = getUserIdentityValues(candidate);
    const nameKey = getNameKey(candidate);

    return (
      identities.some((identity) => lookupIds.includes(identity)) ||
      (normalizedReference?.email && candidate.email === normalizedReference.email) ||
      (referenceName && nameKey === referenceName)
    );
  });

  return match ? normalizeUserShape(match, routeId) : null;
};

const getActiveLabel = (value) => {
  if (value === true || value === 1 || value === "1" || value === "active") return "Active";
  if (value === false || value === 0 || value === "0" || value === "inactive") return "Inactive";
  return null;
};

const pickValue = (...values) => values.find(hasValue);

const ADMIN_ROLE_IDS = new Set(["1", "2", "3"]);

const toInputDate = (value) => {
  return getDateInputValue(value);
};

const buildImageSrc = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${IMAGE_BASE_URL}${path}`;
};

const getEditableProfileFields = (user = {}) => ({
  emp_id: pickValue(user.emp_id, user.employee_id, user.employee_code, ""),
  first_name: user.first_name || "",
  last_name: user.last_name || "",
  email: pickValue(user.email, user.email_id, user.work_email, ""),
  phone_number: pickValue(user.phone_number, user.phone, user.mobile, user.mobile_number, user.contact_number, ""),
  gender: pickValue(user.gender, user.sex, ""),
  job_title: pickValue(user.job_title, user.designation, user.position, ""),
  role_id: pickValue(user.role_id, user.roleId, ""),
  joined_at: toInputDate(pickValue(user.joined_at, user.joining_date, user.created_at)),
  dob: toInputDate(pickValue(user.dob, user.date_of_birth, user.birth_date)),
  alter_contact_name: pickValue(user.alter_contact_name, user.alternate_contact_name, user.emergency_contact_name, ""),
  alter_number: pickValue(user.alter_number, user.alternate_contact_number, user.emergency_contact_number, ""),
  address: user.address || "",
  current_address: user.current_address || "",
  permanent_address: user.permanent_address || "",
  father_name: user.father_name || "",
  mother_name: user.mother_name || "",
  tenth_year: user.tenth_year || "",
  twelfth_year: user.twelfth_year || "",
  graduation_level: user.graduation_level || "",
  graduation_course: user.graduation_course || "",
  graduation_year: user.graduation_year || "",
  post_graduation_level: user.post_graduation_level || "",
  post_graduation_course: user.post_graduation_course || "",
  post_graduation_year: user.post_graduation_year || "",
});
 
export default function UserProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
 
  const passedUser = location.state?.user;
  // const [activeTab, setActiveTab] = useState("profile");
 
 
  const [searchParams] = useSearchParams();
const tabParam = searchParams.get("tab");
  // const currentUserId = user?.id;
// const [activeTab, setActiveTab] = useState(tabParam || "profile");
const [activeTab, setActiveTab] = useState(tabParam || "profile");
 
useEffect(() => {
  setActiveTab(tabParam || "profile");
}, [tabParam]);
 
 
  const [user, setUser] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editOpen, setEditOpen] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [profileImage, setProfileImage] = useState(null);
  const [profilePreview, setProfilePreview] = useState("");
  const [saving, setSaving] = useState(false);
 
  const isAdmin = ADMIN_ROLE_IDS.has(String(currentUser?.role_id || ""));

  const loadFullUser = useCallback(async (cancelledRef = { current: false }) => {
    const canonicalUserId =
      passedUser?.user_id ||
      passedUser?.id ||
      passedUser?.userId ||
      passedUser?.employee_user_id;

    if (canonicalUserId && String(canonicalUserId) !== String(id)) {
      navigate(`/users/${canonicalUserId}`, {
        replace: true,
        state: { user: passedUser },
      });
      return;
    }

    const fallbackUser = passedUser ? normalizeUserShape(passedUser, id) : null;
    const lookupIds = getLookupIds(id, passedUser);

    setUser(fallbackUser);
    setLoading(!fallbackUser);

    try {
      let directUser = null;

      for (const lookupId of lookupIds) {
        const directRes = await getUserByIdApi(lookupId);
        directUser = findUserInResponse(directRes, lookupIds, fallbackUser);

        if (directUser) break;
      }

      if (cancelledRef.current) return;

      if (directUser) {
        setUser(mergeUserRecords(fallbackUser, directUser));
        return;
      }

      const employeesRes = await getEmployeesApi();
      const employeeUser = findUserInResponse(employeesRes, lookupIds, fallbackUser);

      if (!cancelledRef.current) {
        setUser(employeeUser ? mergeUserRecords(fallbackUser, employeeUser) : fallbackUser);
      }
    } catch {
      if (!cancelledRef.current) setUser(fallbackUser);
    } finally {
      if (!cancelledRef.current) setLoading(false);
    }
  }, [id, navigate, passedUser]);

  useEffect(() => {
    const cancelledRef = { current: false };
    loadFullUser(cancelledRef);

    return () => {
      cancelledRef.current = true;
    };
  }, [loadFullUser]);

  useEffect(() => {
    let cancelled = false;

    getProfileApi()
      .then((res) => {
        if (!cancelled && res?.success) setCurrentUser(res.data || res.user || res);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!editOpen || !user) return;
    setEditForm(getEditableProfileFields(user));
    setProfileImage(null);
    setProfilePreview(buildImageSrc(user.profile_pic));
  }, [editOpen, user]);

  const profileStats = useMemo(
    () => ({
      basic: [
        ["Email", pickValue(user?.email, user?.email_id, user?.work_email)],
        ["Phone", pickValue(user?.phone_number, user?.phone, user?.mobile, user?.mobile_number, user?.contact_number)],
        ["Gender", pickValue(user?.gender, user?.sex)],
        ["Job Title", pickValue(user?.job_title, user?.designation, user?.position, user?.role_name)],
        ["Father Name", user?.father_name],
        ["Mother Name", user?.mother_name],
      ],
      emergency: [
        ["Alternate Contact Name", pickValue(user?.alter_contact_name, user?.alternate_contact_name, user?.emergency_contact_name)],
        ["Alternate Contact Number", pickValue(user?.alter_number, user?.alternate_contact_number, user?.emergency_contact_number)],
        ["Current Address", user?.current_address],
        ["Permanent Address", user?.permanent_address],
      ],
      account: [
        ["Employee ID", pickValue(user?.emp_id, user?.employee_id, user?.employee_code, user?.id)],
        ["Role ID", pickValue(user?.role_id, user?.roleId)],
        ["Joined", formatDate(pickValue(user?.joined_at, user?.joining_date, user?.created_at))],
        ["Date of Birth", formatDisplayDate(pickValue(user?.dob, user?.date_of_birth, user?.birth_date))],
        ["10th Completed", user?.tenth_year],
        ["12th Completed", user?.twelfth_year],
        ["Graduation", [user?.graduation_level, user?.graduation_course, user?.graduation_year].filter(Boolean).join(" / ")],
        ["Post Graduation", [user?.post_graduation_level, user?.post_graduation_course, user?.post_graduation_year].filter(Boolean).join(" / ")],
      ],
    }),
    [user]
  );

  const handleEditChange = (event) => {
    const { name, value } = event.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (file) => {
    if (!file) return;
    if (!file.type?.startsWith("image/")) {
      toast.error("Please choose an image file");
      return;
    }

    if (file.size > 8 * 1024 * 1024) {
      toast.error("Image should be less than 8MB");
      return;
    }

    if (profilePreview?.startsWith("blob:")) URL.revokeObjectURL(profilePreview);
    setProfileImage(file);
    setProfilePreview(URL.createObjectURL(file));
  };

  const closeEditModal = () => {
    if (profilePreview?.startsWith("blob:")) URL.revokeObjectURL(profilePreview);
    setEditOpen(false);
    setProfileImage(null);
  };

  const handleSaveProfile = async (event) => {
    event.preventDefault();
    if (!isAdmin) return toast.error("Only admin can update employee profiles");

    setSaving(true);
    try {
      let payload = editForm;

      if (profileImage) {
        payload = new FormData();
        Object.entries(editForm).forEach(([key, value]) => payload.append(key, value ?? ""));
        payload.append(
          "profile_pic",
          await convertImageToWebP(profileImage, { quality: 0.86, maxWidth: 1200, maxHeight: 1200 })
        );
      }

      const res = await updateUserApi(user.id || id, payload);
      if (!res?.success) {
        toast.error(res?.message || "Profile update failed");
        return;
      }

      toast.success("Profile updated");
      closeEditModal();
      await loadFullUser({ current: false });
    } catch (error) {
      toast.error(error?.message || "Profile update failed");
    } finally {
      setSaving(false);
    }
  };
 
  if (loading) {
    return <div className="mt-20 text-center text-white/70">Loading…</div>;
  }
 
  // if (!user) {
  //   return <div className="mt-20 text-center text-white/70">User not found</div>;
  // }
 
 
 
  if (!user) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center px-4">
        <div className="
          relative w-full max-w-xl
          p-8 rounded-3xl
          bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
          text-white
          border border-white/10
          shadow-2xl
          text-center
        ">
 
          {/* Glow Effects */}
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-purple-500/20 blur-3xl rounded-full" />
          <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-fuchsia-500/20 blur-3xl rounded-full" />
 
          {/* Icon */}
          <div className="text-5xl mb-4 opacity-80">🚫</div>
 
          {/* Title */}
          <h2 className="text-2xl font-semibold mb-2">
            User Not Found
          </h2>
 
          {/* Subtitle */}
          <p className="text-sm text-white/70 mb-6">
            This user may have been removed or does not exist anymore.
          </p>
 
          {/* Action Buttons */}
          <div className="flex justify-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="
                px-5 py-2 rounded-lg
                bg-white/10 hover:bg-white/20
                transition
              "
            >
              Go Back
            </button>
 
            <button
              onClick={() => navigate("/employees")}
              className="
                px-5 py-2 rounded-lg
                bg-purple-600 hover:bg-purple-500
                transition
              "
            >
              View Employees
            </button>
          </div>
        </div>
      </div>
    );
  }
 
  return (
    // <div className="max-w-7xl mx-auto px-4 py-6">
    <div className="max-w-7xl mx-auto px-4 py-6 bg-[#f3f4f8] rounded-3xl">
 
 
      {/* ===== HERO ===== */}
      <div className="
        relative rounded-3xl p-6 md:p-8 mb-10
        bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
        text-white shadow-2xl md:mt-14
      ">
        <div className="flex flex-col md:flex-row md:items-center gap-6">
 
          {/* Avatar */}
          <div className="w-24 h-24 rounded-full border-4 border-white/20 overflow-hidden bg-white/10">
            {user.profile_pic ? (
              <img
                src={buildImageSrc(user.profile_pic)}
                className="w-full h-full object-cover"
                alt="profile"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-3xl">
                👤
              </div>
            )}
          </div>
 
          {/* Info */}
          <div className="flex-1">
            <h2 className="text-2xl font-semibold">
              {pickValue(user.name, `${user.first_name || ""} ${user.last_name || ""}`.trim(), user.employee_name)}
            </h2>
            <p className="text-sm opacity-80">{pickValue(user.department_name, user.department, user.dept_name)}</p>
 
            <div className="flex flex-wrap gap-2 mt-2 text-xs">
              <span className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-300">
                {hasValue(user.role_id) ? `Role ID: ${user.role_id}` : "Role unavailable"}
              </span>
              {getActiveLabel(user.is_active) && (
                <span className="px-3 py-1 rounded-full bg-green-500/20 text-green-300">
                  {getActiveLabel(user.is_active)}
                </span>
              )}
            </div>
          </div>
 
          <div className="flex flex-wrap gap-3">
            {isAdmin && (
              <button
                onClick={() => setEditOpen(true)}
                className="inline-flex items-center gap-2 rounded-xl bg-cyan-300/18 px-4 py-2 text-sm font-bold text-cyan-50 ring-1 ring-cyan-200/25 transition hover:bg-cyan-300/25"
              >
                <Pencil className="h-4 w-4" />
                Edit Profile
              </button>
            )}

            <button
              onClick={() => navigate(-1)}
              className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-sm"
            >
              ← Back
            </button>
          </div>
        </div>
      </div>
 
 
<div className="flex gap-2 md:gap-4 mb-6 overflow-x-auto no-scrollbar p-2">
  {["profile", "attendance", "leave","task","documents", "journey"].map((tab) => (
    <button
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`
        px-6 py-2 text-sm font-semibold uppercase tracking-wide
        rounded-full transition-all duration-300
        ${
          activeTab === tab
            ? "bg-gradient-to-r from-purple-500 to-purple-700 text-white shadow-lg scale-105"
            : "bg-[#dbc4f2] text-[#5f1ea0] hover:bg-purple-200 shadow-lg"
 
        }
      `}
    >
      {tab}
    </button>
  ))}
</div>
 
      {/* ===== CONTENT ===== */}
      {activeTab === "profile" && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
 
          <GlassCard title="Basic Information">
            {profileStats.basic.map(([label, value]) => (
              <Stat key={label} label={label} value={value} />
            ))}
          </GlassCard>
 
          <GlassCard title="Emergency Contact">
            {profileStats.emergency.map(([label, value]) => (
              <Stat key={label} label={label} value={value} />
            ))}
          </GlassCard>
 
          <GlassCard title="Account">
            {profileStats.account.map(([label, value]) => (
              <Stat key={label} label={label} value={value} />
            ))}
          </GlassCard>
 
        </div>
      )}
 
      {activeTab === "attendance" && (
        <div className="
          rounded-2xl p-5 mt-4
          bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
          shadow-2xl
        ">
          <UserAttendance userId={id} />
        </div>
      )}
 
{activeTab === "leave" && (
  <div className="mt-4">
    <UserLeavesProfile Id={id} />
  </div>
)}
 
 
 
{activeTab === "task" && (
  <div
    className="
      mt-[-54px]
    "
  >
    <TaskDetails />
  </div>
)}
 
{activeTab === "documents" && (
  <div className="      mt-[-54px]
  ">
    <UserDocuments userId={id} />
  </div>
)}
 
{activeTab === "journey" && (
  <div className="mt-4 p-6 bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f] rounded-3xl border border-white/10 shadow-2xl">
    <UserJourney userId={id} />
  </div>
)}
 
 
      {editOpen && isAdmin && (
        <AdminProfileEditModal
          form={editForm}
          imagePreview={profilePreview}
          saving={saving}
          onChange={handleEditChange}
          onImageChange={handleImageChange}
          onClose={closeEditModal}
          onSubmit={handleSaveProfile}
        />
      )}
 
    </div>
  );
}
 
/* ===== UI HELPERS ===== */
 
function GlassCard({ title, children }) {
  return (
    <div className="
      rounded-2xl p-5
      bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
        text-white backdrop-blur-xl
      border border-white/20
      text-white shadow-xl
    ">
      <h3 className="font-semibold mb-4">{title}</h3>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

function AdminProfileEditModal({
  form,
  imagePreview,
  saving,
  onChange,
  onImageChange,
  onClose,
  onSubmit,
}) {
  return (
    <div className="fixed inset-0 z-[2500] flex items-start justify-center overflow-y-auto bg-[#05010f]/70 px-4 py-8 backdrop-blur-md">
      <div className="relative w-full max-w-5xl overflow-hidden rounded-3xl border border-white/15 bg-[#130d25] text-white shadow-[0_32px_110px_rgba(0,0,0,0.65)]">
        <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(135deg,rgba(34,211,238,0.12),transparent_34%,rgba(168,85,247,0.16))]" />

        <div className="relative flex flex-col gap-4 border-b border-white/10 p-6 md:flex-row md:items-center md:justify-between">
          <div>
            <p className="text-xs font-black uppercase tracking-[0.28em] text-cyan-100/65">
              Admin Only
            </p>
            <h3 className="mt-1 text-2xl font-black">Edit Employee Profile</h3>
            <p className="mt-1 text-sm text-white/55">
              Update profile, contact, account and education information.
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="grid h-11 w-11 place-items-center rounded-2xl border border-white/15 bg-white/10 text-white/70 transition hover:bg-white/16 hover:text-white"
            aria-label="Close edit profile"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <form onSubmit={onSubmit} className="relative max-h-[75vh] overflow-y-auto p-6">
          <div className="mb-6 flex flex-col gap-4 rounded-2xl border border-white/12 bg-white/[0.06] p-4 md:flex-row md:items-center">
            <div className="h-24 w-24 shrink-0 overflow-hidden rounded-3xl border border-white/20 bg-white/10">
              {imagePreview ? (
                <img src={imagePreview} alt="Profile preview" className="h-full w-full object-cover" />
              ) : (
                <div className="grid h-full w-full place-items-center text-white/45">
                  <Camera className="h-8 w-8" />
                </div>
              )}
            </div>

            <div className="min-w-0 flex-1">
              <p className="text-sm font-bold text-white">Profile Image</p>
              <p className="mt-1 text-xs leading-5 text-white/55">
                JPG, PNG or WebP supported. The image is compressed before upload.
              </p>
              <label className="mt-3 inline-flex cursor-pointer items-center gap-2 rounded-xl border border-cyan-200/25 bg-cyan-300/14 px-4 py-2 text-sm font-bold text-cyan-50 transition hover:bg-cyan-300/22">
                <Camera className="h-4 w-4" />
                Choose Photo
                <input
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={(event) => onImageChange(event.target.files?.[0])}
                />
              </label>
            </div>
          </div>

          <EditSection title="Basic Information">
            <EditField label="First Name" name="first_name" value={form.first_name} onChange={onChange} />
            <EditField label="Last Name" name="last_name" value={form.last_name} onChange={onChange} />
            <EditField label="Email" name="email" type="email" value={form.email} onChange={onChange} />
            <EditField label="Phone" name="phone_number" value={form.phone_number} onChange={onChange} />
            <EditField label="Gender" name="gender" value={form.gender} onChange={onChange} />
            <EditField label="Job Title" name="job_title" value={form.job_title} onChange={onChange} />
            <EditField label="Father Name" name="father_name" value={form.father_name} onChange={onChange} />
            <EditField label="Mother Name" name="mother_name" value={form.mother_name} onChange={onChange} />
          </EditSection>

          <EditSection title="Emergency Contact">
            <EditField label="Alternate Contact Name" name="alter_contact_name" value={form.alter_contact_name} onChange={onChange} />
            <EditField label="Alternate Contact Number" name="alter_number" value={form.alter_number} onChange={onChange} />
            <EditArea label="Address" name="address" value={form.address} onChange={onChange} />
            <EditArea label="Current Address" name="current_address" value={form.current_address} onChange={onChange} />
            <EditArea label="Permanent Address" name="permanent_address" value={form.permanent_address} onChange={onChange} />
          </EditSection>

          <EditSection title="Account">
            <EditField label="Employee ID" name="emp_id" value={form.emp_id} onChange={onChange} />
            <EditField label="Role ID" name="role_id" type="number" value={form.role_id} onChange={onChange} />
            <EditField label="Joined" name="joined_at" type="date" value={form.joined_at} onChange={onChange} />
            <EditField label="Date of Birth" name="dob" type="date" value={form.dob} onChange={onChange} />
          </EditSection>

          <EditSection title="Education">
            <EditField label="10th Completed" name="tenth_year" value={form.tenth_year} onChange={onChange} />
            <EditField label="12th Completed" name="twelfth_year" value={form.twelfth_year} onChange={onChange} />
            <EditField label="Graduation Level" name="graduation_level" value={form.graduation_level} onChange={onChange} />
            <EditField label="Graduation Course" name="graduation_course" value={form.graduation_course} onChange={onChange} />
            <EditField label="Graduation Year" name="graduation_year" value={form.graduation_year} onChange={onChange} />
            <EditField label="Post Graduation Level" name="post_graduation_level" value={form.post_graduation_level} onChange={onChange} />
            <EditField label="Post Graduation Course" name="post_graduation_course" value={form.post_graduation_course} onChange={onChange} />
            <EditField label="Post Graduation Year" name="post_graduation_year" value={form.post_graduation_year} onChange={onChange} />
          </EditSection>

          <div className="sticky bottom-0 -mx-6 -mb-6 mt-6 flex justify-end gap-3 border-t border-white/10 bg-[#130d25]/95 p-4 backdrop-blur">
            <button
              type="button"
              onClick={onClose}
              className="rounded-xl border border-white/12 bg-white/10 px-5 py-2.5 text-sm font-bold text-white/75 transition hover:bg-white/16 hover:text-white"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving}
              className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-cyan-500 to-violet-600 px-5 py-2.5 text-sm font-black text-white shadow-lg transition hover:from-cyan-400 hover:to-violet-500 disabled:cursor-not-allowed disabled:opacity-60"
            >
              <Save className="h-4 w-4" />
              {saving ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function EditSection({ title, children }) {
  return (
    <section className="mb-6 rounded-2xl border border-white/12 bg-white/[0.045] p-4">
      <h4 className="mb-4 text-sm font-black uppercase tracking-[0.22em] text-white/58">
        {title}
      </h4>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">{children}</div>
    </section>
  );
}

function EditField({ label, name, value, onChange, type = "text" }) {
  return (
    <label className="block">
      <span className="mb-1 block text-xs font-bold text-white/62">{label}</span>
      <input
        name={name}
        type={type}
        value={value || ""}
        onChange={onChange}
        className="w-full rounded-xl border border-white/14 bg-white/10 px-4 py-2.5 text-sm font-semibold text-white outline-none transition placeholder:text-white/35 focus:border-cyan-200/55 focus:bg-white/14 focus:ring-2 focus:ring-cyan-300/15"
      />
    </label>
  );
}

function EditArea({ label, name, value, onChange }) {
  return (
    <label className="block md:col-span-2">
      <span className="mb-1 block text-xs font-bold text-white/62">{label}</span>
      <textarea
        name={name}
        value={value || ""}
        onChange={onChange}
        rows={3}
        className="w-full resize-none rounded-xl border border-white/14 bg-white/10 px-4 py-2.5 text-sm font-semibold text-white outline-none transition placeholder:text-white/35 focus:border-cyan-200/55 focus:bg-white/14 focus:ring-2 focus:ring-cyan-300/15"
      />
    </label>
  );
}
 
function Stat({ label, value }) {
  return (
    <div>
      <p className="text-xs opacity-60">{label}</p>
      <p className="font-medium">{value || "—"}</p>
    </div>
  );
}
 
function formatDate(date) {
  return formatDisplayDate(date);
}
 






// import { useEffect, useState } from "react";
// import { useParams, useNavigate ,useSearchParams} from "react-router-dom";
// import { getUserByIdApi,getAllDocumentsApi } from "../../app/api";
// import UserAttendance from "../profile/UserAttendanceProfile";
// import UserDocuments from "../profile/UserDocuments";
// import UserLeavesProfile from "../profile/UserLeavesProfile";
// import TaskDetails from "../../pages/dashboard/components/TaskDetails";

// import { useLocation } from "react-router-dom";
// const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

// export default function UserProfile() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const passedUser = location.state?.user;
//   // const [activeTab, setActiveTab] = useState("profile");


//   const [searchParams] = useSearchParams();
// const tabParam = searchParams.get("tab");
//   // const currentUserId = user?.id;
// // const [activeTab, setActiveTab] = useState(tabParam || "profile");
// const [activeTab, setActiveTab] = useState(tabParam || "profile");

// useEffect(() => {
//   setActiveTab(tabParam || "profile");
// }, [tabParam]);


//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
  


//   useEffect(() => {
//     if (passedUser) {
//       setUser(passedUser);
//       setLoading(false);
//     } else {
//       setLoading(true);
//       getUserByIdApi(id)
//         .then((res) => {
//           if (res?.success && Array.isArray(res.data)) {
//             setUser(res.data.find(u => String(u.id) === String(id)) || null);
//           }
//         })
//         .finally(() => setLoading(false));
//     }
//   }, [id, passedUser]);

//   if (loading) {
//     return <div className="mt-20 text-center text-white/70">Loading…</div>;
//   }

//   // if (!user) {
//   //   return <div className="mt-20 text-center text-white/70">User not found</div>;
//   // }



//   if (!user) {
//     return (
//       <div className="min-h-[80vh] flex items-center justify-center px-4">
//         <div className="
//           relative w-full max-w-xl
//           p-8 rounded-3xl
//           bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
//           text-white
//           border border-white/10
//           shadow-2xl
//           text-center
//         ">
  
//           {/* Glow Effects */}
//           <div className="absolute -top-10 -right-10 w-40 h-40 bg-purple-500/20 blur-3xl rounded-full" />
//           <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-fuchsia-500/20 blur-3xl rounded-full" />
  
//           {/* Icon */}
//           <div className="text-5xl mb-4 opacity-80">🚫</div>
  
//           {/* Title */}
//           <h2 className="text-2xl font-semibold mb-2">
//             User Not Found
//           </h2>
  
//           {/* Subtitle */}
//           <p className="text-sm text-white/70 mb-6">
//             This user may have been removed or does not exist anymore.
//           </p>
  
//           {/* Action Buttons */}
//           <div className="flex justify-center gap-3">
//             <button
//               onClick={() => navigate(-1)}
//               className="
//                 px-5 py-2 rounded-lg
//                 bg-white/10 hover:bg-white/20
//                 transition
//               "
//             >
//               Go Back
//             </button>
  
//             <button
//               onClick={() => navigate("/employees")}
//               className="
//                 px-5 py-2 rounded-lg
//                 bg-purple-600 hover:bg-purple-500
//                 transition
//               "
//             >
//               View Employees
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     // <div className="max-w-7xl mx-auto px-4 py-6">
//     <div className="max-w-7xl mx-auto px-4 py-6 bg-[#f3f4f8] rounded-3xl">


//       {/* ===== HERO ===== */}
//       <div className="
//         relative rounded-3xl p-6 md:p-8 mb-10
//         bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
//         text-white shadow-2xl md:mt-14
//       ">
//         <div className="flex flex-col md:flex-row md:items-center gap-6">

//           {/* Avatar */}
//           <div className="w-24 h-24 rounded-full border-4 border-white/20 overflow-hidden bg-white/10">
//             {user.profile_pic ? (
//               <img
//                 src={`${IMAGE_BASE_URL}${user.profile_pic}`}
//                 className="w-full h-full object-cover"
//                 alt="profile"
//               />
//             ) : (
//               <div className="w-full h-full flex items-center justify-center text-3xl">
//                 👤
//               </div>
//             )}
//           </div>

//           {/* Info */}
//           <div className="flex-1">
//             <h2 className="text-2xl font-semibold">
//               {user.first_name} {user.last_name}
//             </h2>
//             <p className="text-sm opacity-80">{user.department_name}</p>

//             <div className="flex gap-2 mt-2 text-xs">
//               <span className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-300">
//                 Role ID: {user.role_id}
//               </span>
//               <span className="px-3 py-1 rounded-full bg-green-500/20 text-green-300">
//                 {user.is_active ? "Active" : "Inactive"}
//               </span>
//             </div>
//           </div>

//           <button
//             onClick={() => navigate(-1)}
//             className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-sm"
//           >
//             ← Back
//           </button>
//         </div>
//       </div>

//       {/* ===== TABS ===== */}
//       {/* <div className="flex gap-3 mb-6">
//         {["profile", "attendance", "leave"].map(tab => (
//           <button
//             key={tab}
//             onClick={() => setActiveTab(tab)}
//             className={`px-5 py-2 rounded-full text-sm transition
//               ${
//                 activeTab === tab
//                   ? "bg-purple-600 text-white shadow"
//                   : "bg-gray-300 text-white hover:bg-purple-600 shadow-lg"
//               }`}
//           >
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div> */}

// <div className="flex gap-4 mb-6">
//   {["profile", "attendance", "leave","task","documents"].map((tab) => (
//     <button
//       key={tab}
//       onClick={() => setActiveTab(tab)}
//       className={`
//         px-6 py-2 text-sm font-semibold uppercase tracking-wide
//         rounded-full transition-all duration-300
//         ${
//           activeTab === tab
//             ? "bg-gradient-to-r from-purple-500 to-purple-700 text-white shadow-lg scale-105"
//             : "bg-[#dbc4f2] text-[#5f1ea0] hover:bg-purple-200 shadow-lg"

//         }
//       `}
//     >
//       {tab}
//     </button>
//   ))}
// </div>

//       {/* ===== CONTENT ===== */}
//       {activeTab === "profile" && (
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

//           <GlassCard title="Basic Information">
//             <Stat label="Email" value={user.email} />
//             <Stat label="Phone" value={user.phone_number} />
//             <Stat label="Gender" value={user.gender} />
//             <Stat label="Job Title" value={user.job_title} />
//           </GlassCard>

//           <GlassCard title="Emergency Contact">
//   <Stat label=" Alternate Contact Name" value={user.alter_contact_name || "—"} />
//   <Stat label=" Alternate Contact Number" value={user.alter_number || "—"} />
// </GlassCard>

//           <GlassCard title="Account">
//             <Stat label="Employee ID" value={user.emp_id} />
//             <Stat label="Role ID" value={user.role_id} />
//             <Stat label="Joined" value={formatDate(user.joined_at)} />
//             <Stat label="Date of Birth" value={user.dob || "—"} />
//           </GlassCard>

//         </div>
//       )}

//       {activeTab === "attendance" && (
//         <div className="
//           rounded-2xl p-5 mt-4
//           bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
//           shadow-2xl
//         ">
//           <UserAttendance userId={id} />
//         </div>
//       )}

// {activeTab === "leave" && (
//   <div className="mt-4">
//     <UserLeavesProfile Id={id} />
//   </div>
// )}



// {activeTab === "task" && (
//   <div
//     className="
//       mt-[-54px]
//     "
//   >
//     <TaskDetails />
//   </div>
// )}

// {activeTab === "documents" && (
//   <div className="      mt-[-54px]
//   ">
//     <UserDocuments userId={id} />
//   </div>
// )}



//     </div>
//   );
// }

// /* ===== UI HELPERS ===== */

// function GlassCard({ title, children }) {
//   return (
//     <div className="
//       rounded-2xl p-5
//       bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
//         text-white backdrop-blur-xl
//       border border-white/20
//       text-white shadow-xl
//     ">
//       <h3 className="font-semibold mb-4">{title}</h3>
//       <div className="space-y-3">{children}</div>
//     </div>
//   );
// }

// function Stat({ label, value }) {
//   return (
//     <div>
//       <p className="text-xs opacity-60">{label}</p>
//       <p className="font-medium">{value || "—"}</p>
//     </div>
//   );
// }

// function formatDate(date) {
//   if (!date) return "—";
//   return date.split(" ")[0];
// }
